// © Microsoft Corporation. All rights reserved.
import React from 'react';
import { Stack, PrimaryButton, Icon, Image, IImageStyles } from '@fluentui/react';
import { VideoCameraEmphasisIcon } from '@fluentui/react-icons-northstar';
import peoplecertLogo from '../assets/peoplecert-logo.png';
import {
    imgStyle,
    containerTokens,
    listStyle,
    iconStyle,
    headerStyle,
    upperStackTokens,
    videoCameraIconStyle,
    buttonStyle,
    nestedStackTokens,
    upperStackStyle,
    listItemStyle
} from './styles/HomeScreen.styles';
import { labelConstants, HomeListItemsConstants, ButtonstConstants } from '../core/constants';
export interface HomeScreenProps {
    startCallHandler(): void;
}

const imageStyleProps: IImageStyles = {
    image: {
        height: '100%',
        width: '100%'
    },
    root: {}
};

export default (props: HomeScreenProps): JSX.Element => {
    const iconName = 'SkypeCircleCheck';
    const imageProps = { src: peoplecertLogo };
    const headerTitle = labelConstants.HeaderTitle;
    const peoplecertlLink = ButtonstConstants.PeoplecertlLink;
    const startCallButtonText = ButtonstConstants.StartCallButtonText;
    const listItems = [
        HomeListItemsConstants.ListItem1,
        HomeListItemsConstants.ListItem2,
        HomeListItemsConstants.ListItem3,
        HomeListItemsConstants.ListItem4
    ];
    return (
        <Stack horizontal horizontalAlign="center" verticalAlign="center" tokens={containerTokens}>
            <Stack className={upperStackStyle} tokens={upperStackTokens}>
                <div className={headerStyle}>{headerTitle}</div>
                <Stack tokens={nestedStackTokens}>
                    <ul className={listStyle}>
                        <li className={listItemStyle}>
                            <Icon className={iconStyle} iconName={iconName} /> {listItems[0]}
                        </li>
                        <li className={listItemStyle}>
                            <Icon className={iconStyle} iconName={iconName} /> {listItems[1]}
                        </li>
                        <li className={listItemStyle}>
                            <Icon className={iconStyle} iconName={iconName} /> {listItems[2]}
                        </li>
                        <li className={listItemStyle}>
                            <Icon className={iconStyle} iconName={iconName} /> {listItems[3]}{' '}
                            <a href="https://www.peoplecert.org">
                                {peoplecertlLink}
                            </a>
                        </li>
                    </ul>
                </Stack>
                <PrimaryButton className={buttonStyle} onClick={props.startCallHandler}>
                    <VideoCameraEmphasisIcon className={videoCameraIconStyle} size="medium" />
                    {startCallButtonText}
                </PrimaryButton>
            </Stack>
            <Image
                alt={labelConstants.HomeImageAlt}
                className={imgStyle}
                styles={imageStyleProps}
                {...imageProps}
            />
        </Stack>
    );
};
